import React from 'react'
import { formatDateYYYYMMDD } from '../../packages/utils/numberFormatters'
import { useAppLocale } from '../../i18n/localeUtils'
import { Tooltip } from '@mui/material'
import { EnrichedWarrantSingleItem } from 'types/WarrantEntity'

const formatSubscriptionPeriodsEndDates = (
    subscriptionPeriods: EnrichedWarrantSingleItem['subscriptionPeriods'],
    language: string,
) => {
    return subscriptionPeriods.map((period) => formatDateYYYYMMDD(period.subEndDate, { locale: language })).join(', ')
}

const formatWarrantSubEndDates = (
    warrant: Pick<EnrichedWarrantSingleItem, 'subEndDate' | 'subscriptionPeriods'>,
    language: string,
) => {
    if (!warrant) return ''

    const subEndDate = formatDateYYYYMMDD(warrant.subEndDate, { locale: language })

    return warrant.subscriptionPeriods?.length > 1 ? (
        <Tooltip arrow title={formatSubscriptionPeriodsEndDates(warrant.subscriptionPeriods, language)} placement='top'>
            <span>{subEndDate + ' *'}</span>
        </Tooltip>
    ) : (
        subEndDate
    )
}

function WarrantSubEndDate({
    warrant,
}: {
    warrant: Pick<EnrichedWarrantSingleItem, 'subEndDate' | 'subscriptionPeriods'>
}) {
    const { language } = useAppLocale()
    return <>{formatWarrantSubEndDates(warrant, language)}</>
}

export { WarrantSubEndDate, formatWarrantSubEndDates }
